import React from 'react';
import { colors } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import GlobeIllustration from 'svg/illustrations/Globe';

const Benefits = () => {
  const sections = [
    {
      title: 'Salud preventiva',
      subtitle: 'Chequeos, hábitos y prevención para anticiparse y vivir mejor.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: colors.green,
    },
    {
      title: 'Bienestar mental',
      subtitle: 'Equilibrio emocional, estrés y autocuidado con enfoque práctico.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: colors.pink,
    },
    {
      title: 'Nutrición y hábitos',
      subtitle: 'Alimentación consciente y rutinas sostenibles para el día a día.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
      ),
      color: colors.orange,
    },
    {
      title: 'Especialistas invitados',
      subtitle: 'Entrevistas con médicos y expertos en temas de salud actual.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      color: colors.blue,
    },
    {
      title: 'Familia y autocuidado',
      subtitle: 'Salud para todas las edades: padres, adultos y adultos mayores.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      color: colors.teal,
    },
    {
      title: 'Marcas de salud',
      subtitle: 'Patrocinio orgánico en un entorno de confianza médica y cercanía.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      color: colors.indigo,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color={'primary'} align={'center'}>
          Temas
        </Typography>
        <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h3'} gutterBottom align={'center'} color={'primary'}>
          Salud integral en un solo espacio
        </Box>
        <Typography align={'center'} color="textSecondary" variant={'h6'}>
          En Sintonía con tu Salud conecta prevención, bienestar y especialistas. Cada eje abre patrocinio para marcas del sector salud y wellness.
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} marginBottom={4} data-aos={'fade-up'}>
        <Box maxWidth={300} width={'100%'}>
          <GlobeIllustration width={'100%'} height={'100%'} />
        </Box>
      </Box>
      <Grid container spacing={4}>
        {sections.map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box height={1} display={'flex'} flexDirection={'column'} data-aos={'fade-up'} data-aos-delay={i * 100}>
              <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} marginBottom={2}>
                <Box component={Avatar} width={60} height={60} marginRight={2} bgcolor={item.color[50]} color={item.color[900]}>
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant={'h6'} gutterBottom sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                </Box>
              </Box>
              <Typography color="textSecondary">{item.subtitle}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
